import React, { useRef, useState } from "react";
import "@delibrandev/utils/src/components/cardList/style.css";
import "./style.css";

export const AccessSelector = ({ head, title, icon, data = [], callback, emptyMessage }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  const select = async item => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setError("");
    try { await callback(item); }
    catch { setError("No se ha podido seleccionar. Vuelve a intentarlo."); }
    finally { inFlight.current = false; setBusy(false); }
  };
  return <div className="accessSelector" aria-busy={busy}>
    <h2 className="loginTitle">{head}</h2>
    <div className="cardLabel">{title}</div>
    <div className="cardList" role="group" aria-label={title}>
      {data.map(item => <button type="button" className="cardUser"
        key={item.orderManagerConfigurationId || item.userId}
        disabled={busy} onClick={() => select(item)}
        onKeyDown={event => {
          if (event.key === "Enter" || event.key === " ") { event.preventDefault(); select(item); }
        }}>
        <span className="userIcon" aria-hidden="true">{icon}</span>
        <span className="username ellipsis">{item.fullname || item.name}</span>
      </button>)}
    </div>
    {!data.length && <p role="status">{emptyMessage}</p>}
    {busy && <p role="status">Seleccionando…</p>}
    {error && <p role="alert">{error}</p>}
  </div>;
};
